
import { DashboardReportTable } from '../dashboard-report-table';

import { IColumnMenu } from '@constants';

import './style.scss';

interface IProps {
  loading: boolean;
  topList: any[] | undefined;
  header: IColumnMenu[];
}

export function DashboardReportTopBase(props: IProps) {
  const { loading, topList, header } = props;

  return (
    <div>
      <DashboardReportTable loading={loading} list={topList} header={header} />
    </div>
  );
}
